import { makeStyles } from "tss-react/mui"
import { IconSize } from "./types"

const textSpacingReset = {
  letterSpacing: "normal !important",
  wordSpacing: "normal !important",
  lineHeight: "1 !important"
}

const iconBase = {
  ...textSpacingReset,
  display: "inline-flex !important",
  alignItems: "center",
  justifyContent: "center",
  "&::before, &::after": {
    ...textSpacingReset
  }
}

export const useStyles = makeStyles<void, IconSize>()(() => ({
  xxsmall: {
    ...iconBase,
    fontSize: "0.5rem"
  },
  xsmall: {
    ...iconBase,
    fontSize: "0.6875rem"
  },
  regular: {
    ...iconBase,
    fontSize: "0.75rem"
  },
  small: {
    ...iconBase,
    fontSize: "0.875rem"
  },
  med: {
    ...iconBase,
    fontSize: "1rem"
  },
  large: {
    ...iconBase,
    fontSize: "1.25rem"
  },
  xlarge: {
    ...iconBase,
    fontSize: "2.25rem"
  },
  inherit: {
    ...iconBase,
    fontSize: "inherit"
  },
  unset: {
    ...iconBase
  },

  // CustomIcon styles
  customIcon: {
    display: "flex",
    width: "fit-content",
    height: "fit-content"
  }
}))
